import { ModalSpace, useModal } from 'src/components/Modal/provider'
import ModalView from 'src/components/Modal/view'
import Rop03ModalView from 'src/pages/Rop03JoinFormPage/components/Modal/view'
import Rop04ModalView from 'src/pages/Rop04JoinFormPage/components/Modal/view'
import RenderIf from 'src/components/RenderIf'

export interface ModalProps {
  modalData: ModalSpace.ModalData
  onCancelInternal: () => void
  onSubmitInternal: () => void
}

const Modal = () => {
  const { isOpen, closeModal, modalData } = useModal()
  const { button, when, type } = modalData

  if (!isOpen || !when) {
    return null
  } else {
  }

  const onCancelInternal = () => {
    button?.cancel?.func?.()
    closeModal()
  }

  const onSubmitInternal = () => {
    if (!!button?.submit?.func) {
      button?.submit?.func?.()
    } else {
      closeModal()
    }
  }

  const props: ModalProps = {
    modalData,
    onCancelInternal,
    onSubmitInternal,
  }

  return (
    <>
      <RenderIf when={type === 'rop03'}>
        <Rop03ModalView {...props} />
      </RenderIf>
      <RenderIf when={type === 'rop04'}>
        <Rop04ModalView {...props} />
      </RenderIf>
      <RenderIf when={type !== 'rop03' && type !== 'rop04'}>
        <ModalView {...props} />
      </RenderIf>
    </>
  )
}

export default Modal
